import { OrderTag } from "@deliverr/commons-objects";

export const isDisposalOrder = (order): boolean => order.tags.includes(OrderTag.INVENTORY_DISPOSAL);
